<template>

  <PrimeToast />
  <ConfirmDialog />

  <!-- Success Dialog -->
  <PrimeDialog header="Success" v-model:visible="showSuccessDialog" modal>
    <p>{{ successMessage }}</p>
    <template #footer>
      <PrimeButton label="OK" icon="pi pi-check" @click="showSuccessDialog = false" />
    </template>
  </PrimeDialog>

  <!-- Email Duplicate Dialog -->
  <PrimeDialog header="Email Duplicate" v-model:visible="showEmailDuplicateDialog" modal>
    <p>The email supplied has already been used to fill an application</p>
    <!-- <p>The email supplied has alread been used to fill an application</p> -->
    <template #footer>
      <PrimeButton label="OK" @click="showEmailDuplicateDialog = false" />
    </template>
  </PrimeDialog>



  <!-- Completed Dialog -->
  <PrimeDialog header="Success" v-model:visible="showCompleteDialog" modal>
    <p>Application successfully submitted</p>
    <template #footer>
      <PrimeButton label="OK" icon="pi pi-check" @click="completeRedirect" />
    </template>
  </PrimeDialog>

  <!-- Error Dialog -->
  <PrimeDialog header="Oops!" v-model:visible="showErrorDialog" modal>
    <p>{{ errorMessage }}</p>
    <template #footer>
      <PrimeButton label="OK" icon="pi pi-check" @click="showErrorDialog = false" />
    </template>
  </PrimeDialog>


  <!-- Error Dialog -->
  <PrimeDialog header="Whoops!" v-model:visible="showRetryDialog" modal>
    <p>Whoops! Something went wrong...</p>
    <template #footer>
      <PrimeButton label="Retry" icon="pi pi-refresh" @click="sendToken" />

      <PrimeButton severity="danger" label="Cancel" icon="pi pi-times" @click="showRetryDialog = false" />
    </template>
  </PrimeDialog>



  <div class="grid ">

    <div
      class=" container-fluid  col-12 lg:col-offset-2 col-12 sm:col-offset-2  lg:col-9 md:col-8 p-2  border-round  align-items-center">

      <!-- <div class="flex justify-content-between">
        <img class=" fadeinleft animation-duration-1000" height="100" src="@/assets/201119_ELdZ.png" alt="" srcset="">
        <img class="fadeinright animation-duration-1000" height="150" src="@/assets/201119_GIZ.png" alt="" srcset="">

      </div> -->

      <div v-if="start" class="startcss  ">

        <div class=" flex align-items-center justify-content-center p-2 bg-white-alpha-50 mb-2 h-20rem ">

          <div class="container-fluid grid gap-3 align-items-center">
            <div class="col-12 lg:col-6 bg-cyan-200 border-round">
              <h4>Online Application</h4>
              <p>Click on Start to start a new application or click on Resume to continue a previous application</p>
            </div>

            <div class="flex flex-column gap-3 col-12 lg:col-4">
              <PrimeButton @click="activateModule('main')" severity="success" label="Start" class="w-full" />

              <PrimeButton @click="activateModule('resume')" label="Resume" class="w-full" />
            </div>
          </div>
        </div>


      </div>



      <div v-if="main" id="main">


        <div>

          <form @submit.prevent="submitConfirmation" class="form-container">
            <!-- Step One -->
            <div>
              <h2>Get A Quote</h2>

              <h4 class="text-black-alpha-80">**All fields marked <b><span class="required">*</span></b> are mandatory.
              </h4>


              <div class="formgrid grid">



                <!-- Form 1 -->
                <div id="form1" v-if="formData.step == 1" class="col-12">

                  <PrimeCard class="">
                    <template #header>
                      <!-- <img alt="user header" src="/images/usercard.png" /> -->
                      <h3 class=" m-3 text-black-alpha-70 ">STEP 1</h3>
                    </template>
                    <!-- <template #subtitle>Contact Information</template> -->
                    <!-- <template #subtitle>Card subtitle</template> -->
                    <template #content>

                      <!-- <div class="flex gap-2 flex-wrap flex-column lg:flex-row "> -->
                      <div class="grid">


                        <!-- fullname -->
                        <div class="field col-12 md:col-6 ">
                          <div :class="{ error: v$.formData.fullname.$errors.length }"> </div>
                          <label for="fullname"> Full Name: <span class="required">*</span></label>
                          <PrimeInputText :invalid="v$.formData.fullname.$errors.length > 0" v-model="formData.fullname"
                            class="w-full" id="fullname" />
                          <div class="input-errors" v-for="error of v$.formData.fullname.$errors" :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>


                        </div>

                        <!-- email -->
                        <div class="field col-12 md:col-6 ">
                          <div :class="{ error: v$.formData.email.$errors.length }"> </div>
                          <label for="email1">Email: <span class="required">*</span></label>
                          <PrimeInputText :invalid="v$.formData.email.$errors.length > 0" v-model="formData.email"
                            class="w-full" id="email" />
                          <div class="input-errors" v-for="error of v$.formData.email.$errors" :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>


                        </div>


                        <!-- phone -->
                        <div class="field col-12 md:col-6 ">
                          <div :class="{ error: v$.formData.phone.$errors.length }"> </div>
                          <label for="phone">Phone: <span class="required">*</span></label>
                          <PrimeInputText :invalid="v$.formData.phone.$errors.length > 0" v-model="formData.phone"
                            class="w-full" id="phone" />
                          <div class="input-errors" v-for="error of v$.formData.phone.$errors" :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>


                        </div>



                        <!-- contact_method -->
                        <div class="field col-12 md:col-6 ">
                          <div :class="{ error: v$.formData.contact_method.$errors.length }"> </div>
                          <label for="contact_method">Preferred Contact Method: <span class="required">*</span></label>

                          <PrimeDropdown :invalid="v$.formData.contact_method.$errors.length > 0" id="contact_method"
                            class="w-full" v-model="formData.contact_method" :options="$menus.contactMethodOptions"
                            optionLabel="label" optionValue="value" @blur="v$.formData.contact_method.$touch()"
                            placeholder="Select..." />


                          <!-- <PrimeInputText :invalid="v$.formData.contact_method.$errors.length > 0" v-model="formData.contact_method"
                            class="w-full" id="contact_method" /> -->
                          <div class="input-errors" v-for="error of v$.formData.contact_method.$errors"
                            :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>


                        </div>



                      </div>


                      

                    </template>
                    <template #footer>
                      <PrimeButton label="Next" icon="pi pi-arrow-circle-right" @click="goNext" />

                    </template>
                  </PrimeCard>
                </div>

                <!-- Form 2 -->

                <div id="form2" v-if="formData.step == 2" class="col-12">

                  <PrimeCard class=" p-2 m-3">
                    <template #header>
                      <!-- <img alt="user header" src="/images/usercard.png" /> -->
                      <h3 class=" m-3">STEP 2</h3>

                    </template>
                    <!-- <template #subtitle>Contact Information</template> -->
                    <!-- <template #subtitle>Card subtitle</template> -->

                    <template #content>
                      <div class="grid">


                        <!--entity_type -->
                        <div class="field  col-12 md:col-6">
                          <div :class="{ error: v$.formData.entity_type.$errors.length }"> </div>

                          <label for="entity_type">Business Entity Type <span class="required">*</span></label>

                          <PrimeDropdown :invalid="v$.formData.entity_type.$errors.length > 0" id="entity_type"
                            class="w-full" v-model="formData.entity_type" :options="$menus.businessType"
                            optionLabel="label" optionValue="value" @blur="v$.formData.entity_type.$touch()"
                            placeholder="Select..." />


                          <div class="input-errors" v-for="error of v$.formData.entity_type.$errors" :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>


                        </div>

                        <!--other_ownership_type -->

                        <!-- <div v-if="formData.entity_type == 'Tests'" class="field  col-12 md:col-4">
                          <div v-if="formData.entity_type == 'Other'">
                            <div :class="{ error: v$.formData.other_entity_type.$errors.length }"></div>
                            <label for="other_entity_type">Specify Other
                           
                            </label>
                            <PrimeInputText :invalid="v$.formData.other_ownership_type.$errors.length > 0"
                              v-model="formData.other_ownership_type" class="w-full"
                              @blur="v$.formData.other_ownership_type.$touch()" id="other_ownership_type" />
                            <div class="input-errors" v-for="error of v$.formData.other_ownership_type.$errors"
                              :key="error.$uid">
                              <div class="error-msg">{{ error.$message }}</div>
                            </div>
                          </div>
                        </div> -->



                        <!-- requested_services -->
                        <div class="field col-12 md:col-6">
                          <div :class="{ error: v$.formData.requested_services.$errors.length }"></div>
                          <label for="requested_services">Requested Services: <span class="required">*</span></label>


                          <MultiSelect :invalid="v$.formData.requested_services.$errors.length > 0" class="w-full mb-2"
                            v-model="formData.requested_services" :options="$menus.servicesOptions" optionLabel="label"
                            optionValue="value" @blur="v$.formData.requested_services.$touch()" placeholder="Select"
                            :maxSelectedLabels="6" />

                          <div class="input-errors" v-for="error of v$.formData.requested_services.$errors"
                            :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>
                        </div>


                        <!-- vat_registered -->
                        <div class="field col-12 md:col-6">
                          <div :class="{ error: v$.formData.vat_registered.$errors.length }"></div>
                          <label for="vat_registered">Are you registered with VAT? <span
                              class="required">*</span></label>


                          <PrimeDropdown :invalid="v$.formData.vat_registered.$errors.length > 0" id="transport"
                            v-model="formData.vat_registered" :options="$menus.yesNoOptions" optionLabel="label"
                            optionValue="value" @blur="v$.formData.vat_registered.$touch()" placeholder="Select..."
                            class="w-full" />


                          <div class="input-errors" v-for="error of v$.formData.vat_registered.$errors"
                            :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>
                        </div>


                        <!-- annual_revenue  -->
                        <div class="field col-12 md:col-6">
                          <div :class="{ error: v$.formData.annual_revenue.$errors.length }"></div>
                          <label for="annual_revenue">Annual Revenue
                            <!-- <span
                              class="required">*</span> -->
                          </label>
                          <PrimeInputText :invalid="v$.formData.annual_revenue.$errors.length > 0"
                            v-model="formData.annual_revenue" class="w-full" @blur="v$.formData.annual_revenue.$touch()"
                            id="annual_revenue" />
                          <div class="input-errors" v-for="error of v$.formData.annual_revenue.$errors"
                            :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>
                        </div>





                      </div>




                    </template>

                    <template #footer>
                    
                        <PrimeButton severity="secondary" class="mr-2" label="Back" icon="pi pi-arrow-circle-left" @click="goBack" />
                        <PrimeButton label="Next" icon="pi pi-arrow-circle-right" @click="goNext" />
                     
                    </template>

                  </PrimeCard>




                </div>



                <!-- Form 3 -->

                <div id="form3" v-if="formData.step == 3" class="col-12">


                  <PrimeCard class=" p-2 m-3">
                    <template #header>
                      <!-- <img alt="user header" src="/images/usercard.png" /> -->
                      <h4>SECTION I: DECLARATION</h4>
                    </template>
                    <!-- <template #subtitle>Contact Information</template> -->
                    <!-- <template #subtitle>Card subtitle</template> -->
                    <template #content>


                      <div class="grid">


                        <!-- monthly_transactions  -->
                        <div class="field col-12 md:col-6">
                          <div :class="{ error: v$.formData.monthly_transactions.$errors.length }"></div>
                          <label for="monthly_transactions">Number of Monthly Transactions
                            <!-- <span
                              class="required">*</span> -->
                          </label>
                          <PrimeInputText :invalid="v$.formData.monthly_transactions.$errors.length > 0"
                            v-model="formData.monthly_transactions" class="w-full"
                            @blur="v$.formData.monthly_transactions.$touch()" id="monthly_transactions" />
                          <div class="input-errors" v-for="error of v$.formData.monthly_transactions.$errors"
                            :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>
                        </div>

                        <!-- number_of_employees  -->
                        <div class="field col-12 md:col-6">
                          <div :class="{ error: v$.formData.num_of_employees.$errors.length }"></div>
                          <label for="num_of_employees">Number of Employees
                            <!-- <span
                              class="required">*</span> -->
                          </label>
                          <PrimeInputText :invalid="v$.formData.num_of_employees.$errors.length > 0"
                            v-model="formData.num_of_employees" class="w-full"
                            @blur="v$.formData.num_of_employees.$touch()" id="num_of_employees" />
                          <div class="input-errors" v-for="error of v$.formData.num_of_employees.$errors"
                            :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>
                        </div>



                        <!-- currency_used  -->
                        <div class="field col-12 md:col-6">
                          <div :class="{ error: v$.formData.currency_used.$errors.length }"></div>
                          <label for="currency_used">Select Currency
                            <!-- <span
                              class="required">*</span> -->
                          </label>

                          <PrimeDropdown :invalid="v$.formData.currency_used.$errors.length > 0" id="transport"
                            v-model="formData.currency_used" :options="$menus.currencyOptions" optionLabel="label"
                            optionValue="value" @blur="v$.formData.currency_used.$touch()" placeholder="Select..."
                            class="w-full" />


                          <div class="input-errors" v-for="error of v$.formData.currency_used.$errors"
                            :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>
                        </div>




                        <!-- accounting_software  -->
                        <div class="field col-12 md:col-6">
                          <div :class="{ error: v$.formData.accounting_software.$errors.length }"></div>
                          <label for="accounting_software">Which Accounting Software do you use?(if applicable)
                            <!-- <span
                              class="required">*</span> -->
                          </label>
                          <PrimeInputText :invalid="v$.formData.accounting_software.$errors.length > 0"
                            v-model="formData.accounting_software" class="w-full"
                            @blur="v$.formData.accounting_software.$touch()" id="accounting_software" />
                          <div class="input-errors" v-for="error of v$.formData.accounting_software.$errors"
                            :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>
                        </div>






                        <br>

<div class="flex flex-column gap-3">

                        <h3>GDPR Consent</h3>

                        <div class="flex align-items-center">
                          <div :class="{ error: v$.formData.declare_gdpr.$errors.length }"> </div>
                          <input type="checkbox" id="declare_gdpr" :checked="formData.declare_gdpr === 'Yes'"
                            @change="formData.declare_gdpr = $event.target.checked ? 'Yes' : 'No'" />
                          <label for="declare_gdpr" class="ml-2">
                            I consent to data verification and processing under GDPR.
                          </label>
                          <div class="input-errors" v-for="error of v$.formData.declare_gdpr.$errors"
                            :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                          </div>
                        </div>

                        <div class="flex align-items-center">

                          <div class="input-errors" v-for="error of v$.formData.declare_gdpr.$errors"
                            :key="error.$uid">

                          </div>
                        </div>
                      </div>


                       


                      </div>




                    </template>
                    <template #footer>


                    <PrimeButton severity="secondary" class="mr-2" label="Back" icon="pi pi-arrow-circle-left" @click="goBack" />
                    <PrimeButton style="font-size: 1.1rem" type="submit" :loading="loading" label="Submit"
                            severity="success" icon="pi pi-send" />


                      

                    </template>


                  </PrimeCard>


                </div>



              </div>



            </div>



          </form>
        </div>


      </div>




    </div>
  </div>


</template>


<script>
/* eslint-disable */
import { useConfirm } from "primevue/useconfirm";
import { useToast } from 'primevue/usetoast';
import { ConfirmDialog } from 'primevue/confirmdialog';
import { useVuelidate } from '@vuelidate/core'
import { required, requiredIf, email, helpers, nullable, between } from '@vuelidate/validators'
import axios from 'axios';
import { debounce } from 'lodash';

// const confirm = useConfirm();


 //const baseUrl = "http://localhost/nessa";
const baseUrl = "https://crmapi.nessakud.com";
const phoneCheck = helpers.regex(/^0[2-5]\d{8}$/);
const endpoints = {
  onboard: baseUrl + "/customers/onboard", //submit
  apply: baseUrl + "/api/applications/apply", //submit
  save: baseUrl + "/api/applications/saveprogress",
  sendtoken: baseUrl + "/api/applications/sendtoken",
  retrieve: baseUrl + "/api/applications/retrieve",
  update: baseUrl + "/api/applications/update",
  autosave: baseUrl + "/api/applications/autosave",
  checkemailexists: baseUrl + "/api/components_data/applications_email_exist/"



}

export default {
  setup() {
    return { v$: useVuelidate() }
  },
  props: ['params'],
  data() {
    return {
      //apiBase: 'http://localhost/nessa/',
      apiBase: 'https://crmapi.nessakud.com/',
      start: false,
      resume: false, // activates resume panel
      main: false,
      visible: true,
      is_update: false,//set if form is retrieve. If current operation is an update
      retrieval_email: '',//email which the token is sent to
      token_received: false,//true if token is received
      token: '', // token value
      sending_token: false,
      showRetryDialog: false,
      showEmailDuplicateDialog: false,
      totalSize: 0,
      totalSizePercent: 0,
      autosaving: false,
      old_email: '',
      loading: false,
      saving: false,
      buttonText: "Verify",
      buttonDisable: true,
      showSuccessDialog: false,
      showCompleteDialog: false,
      showErrorDialog: false,
      uploadProgress: 0,
      countDown: '00:00',
      tokenExpired: '',
      canResendToken: false,
      filePath: '',

      endpoints: {
        upload_business_certificate: baseUrl + "/api/fileuploader/upload/business_certificate",
        upload_operations_evidence: baseUrl + "/api/fileuploader/upload/operations_evidence",
        upload_green_evidence: baseUrl + "/api/fileuploader/upload/green_evidence",
        upload_financial_statement: baseUrl + "/api/fileuploader/upload/financial_statement",
        upload_pitch_deck: baseUrl + "/api/fileuploader/upload/pitch_deck",
        upload_osh_upload: baseUrl + "/api/fileuploader/upload/osh_upload",
        upload_business_plan: baseUrl + "/api/fileuploader/upload/business_plan",
      },
      formPDFLink: "https://greenfinancefacilitator.com/documents/The_GFF_Application_Form.pdf",
      formExcelLink: "https://greenfinancefacilitator.com/documents/The_GFF_Application_Form.xlsx",

      formData: {
        customer_id: '',
        reference_number: '',
        fullname: '',
        phone: '',
        email: '',
        contact_method: '',
        entity_type: '',
        position: '',
        requested_services: '',
        vat_registered: '',
        annual_turnover: '',
        annual_revenue: '',
        monthly_transactions: '',
        num_of_employees: '',
        currency_used: '',
        accounting_software: '',
        step: 1,
        ownership_type: '',
        other_ownership_type: '',
        declare_gdpr: '',

      },








      selectedSector: "",
      selectedSubsector: "",

      ownership: [
        {
          name: '',
          percentage: '',
          role: '',
          gender: '',
        },

      ],
      other_docs: [

      ],
      operation_evidence_docs: [

      ],

      green_practice_docs: [

      ],

      osh_docs: [

      ],


      other_doc_name: '',
      other_doc_name_specify: '',
      other_uploading: false,
      acceptedFormats: '.pdf, .xlsx,.xls,.doc,.docx,.odt,.ppt,.pptx image/*',

      social_media_platforms: [
        {
          platform: '',
          handle: ''

        },

      ],




      errorMessage: '',
      successMessage: '',
      verifyLaterMessage: 'It seems you are having trouble verifying your identity. You would like to verify it later?',


    };
  },
  validations() {
    const startsWithZero = (value) => /^0\d+$/.test(value);
    return {
      formData: {
        fullname: {},
        phone: {},
        email: {},
        contact_method: {},
        entity_type: {},

        requested_services: {},
        vat_registered: {},
        annual_turnover: {},
        annual_revenue: {},
        monthly_transactions: {},
        num_of_employees: {},
        currency_used: {},
        accounting_software: {},
        // phone: { required, startsWithZero },
        declare_gdpr: { required },


      },


    }
  },
  computed: {
    isAccepted() {
      return this.formData.terms_and_conditions === 'Yes';
    },
    isNationalID() {
      return this.formData.identification_type === 'National ID';

    },
    isForeigner() {
      return this.formData.identification_type === 'Passport';

    },

    calculateMaxDate() {
      const today = new Date();
      const year = today.getFullYear() - 18;
      const month = today.getMonth();
      const day = today.getDate();
      return new Date(year, month, day);
    }
  },
  mounted() {
    // Access the route param when the component mounts
    this.param = this.$route.params.params;
    //console.log('Route param on mount:', this.params);
    if (this.params == 'start') {
      this.main = true
    } else {
      this.resume = true
    }

    // this.autoSaveInterval = setInterval(() => {
    //   this.autoSave();
    // }, 45000);
  },

  beforeDestroy() {
    // Clear the interval when the component is destroyed
    if (this.autoSaveInterval) {
      clearInterval(this.autoSaveInterval);
    }
  },
  methods: {



    async handleSubmit() {
      // console.log(this.formData)
      this.v$.$touch();
      const result = await this.v$.$validate()

      // const invalidFields = [];

      // // Check each field for $invalid
      // for (const field in this.v$.formData) {
      //   if (this.v$.formData[field].$invalid) {
      //     invalidFields.push(field);
      //   }
      // }
      // console.log(invalidFields);
      // console.log(result);
      if (!result) {
        // notify user form is invalid
        // alert('All fields marked * are mandatory');

        //window.scrollTo({ top: 250, behavior: 'smooth' });

        this.$toast.add({ severity: 'error', summary: 'Info', detail: 'Some fields are missing or incorrect. Please fix them to proceed', life: 6000 });


      } else {
        this.loading = true;
        try {
          // this.formData.operations_evidence = JSON.stringify(this.operation_evidence_docs);
          // this.formData.green_evidence = JSON.stringify(this.green_practice_docs);
          // this.formData.osh_upload = JSON.stringify(this.osh_docs);
          // this.formData.green_practice_select = JSON.stringify(this.formData.green_practice_select);
          // this.formData.indicate_loan_type = JSON.stringify(this.formData.indicate_loan_type);
          // this.formData.osh_select = JSON.stringify(this.formData.osh_select);

          const response = await axios.post(endpoints.onboard, this.formData);


          if (response.data.code == "00") {

            this.$toast.add({ severity: 'success', summary: 'Info', detail: 'Application submitted successfully', life: 3000 });

            this.showCompleteDialog = true;
            this.loading = false;
            this.resetForm();
            this.$router.push({ name: 'Complete', params: { params: 'success' } });

          } else {

            this.errorMessage = "Unable to submit application"
            this.showErrorDialog = true;
            this.loading = false;

            this.loading = false;
          }
        } catch (error) {



          this.errorMessage = "Unable to submit application"
          this.showErrorDialog = true;
          this.loading = false;

          this.loading = false;
        }

      }
    },

    async saveProgress() {
      //const result = await this.v$.$validate()
      //this.v$.$touch();
      alert('save progress clicked');

      if (this.fieldsEmpty()) {

        //const result = await this.v$.$validate()
        window.scrollTo({ top: 250, behavior: 'smooth' });
        this.$toast.add({ severity: 'error', summary: 'Mandatory Fields', detail: 'Kindly fill out the Contact Information section before saving progress', life: 6000 });
        // this.confirm1();
      } else {
        this.saving = true;
        try {
          this.formData.operations_evidence = JSON.stringify(this.operation_evidence_docs);
          this.formData.green_evidence = JSON.stringify(this.green_practice_docs);
          this.formData.osh_upload = JSON.stringify(this.osh_docs);
          this.formData.green_practice_select = JSON.stringify(this.formData.green_practice_select);
          this.formData.indicate_loan_type = JSON.stringify(this.formData.indicate_loan_type);
          this.formData.osh_select = JSON.stringify(this.formData.osh_select);
          const response = await axios.post(endpoints.apply, this.formData);

          if (response.data.code == "00") {
            //alert('Form submitted successfully');
            // this.showSuccessDialog = true;
            //window.location.replace("https://jcs.com.gh");
            //this.confirm1();

            this.token = '';
            this.retrieval_email = '';
            this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Application saved successfully', life: 4000 });

            this.resetForm();
            //this.activateModule('start');

            this.saving = false;
            this.$router.push({ name: 'Complete', params: { params: 'update' } });

          } else {


            if (response.data.message) {
              this.errorMessage = response.data.message;
            } else {
              this.errorMessage = "Unable to save form at this time. Kindly retry later";
            }


            this.showErrorDialog = true;
            //alert("error submitting");
            //console.error('Error submitting form:', error);
            // Handle error (e.g., display an error message)
            this.saving = false;
          }
        } catch (error) {

          this.errorMessage = "Unable to save form at this time. Kindly retry later";
          this.showErrorDialog = true;
          //alert("error submitting");
          //console.error('Error submitting form:', error);
          // Handle error (e.g., display an error message)
          this.saving = false;


        }

      }


    },


    async updateApplication() {

      //if (this.fieldsEmpty()) {
      if (false) {
        window.scrollTo({ top: 250, behavior: 'smooth' });
        this.$toast.add({ severity: 'error', summary: 'Mandatory Fields', detail: 'Kindly fill out the Contact Information section before saving progress', life: 6000 });
      } else {

        this.saving = true;
        try {
          this.formData.owners = JSON.stringify(this.ownership);
          this.formData.other_documents = JSON.stringify(this.other_docs)
          const response = await axios.post(endpoints.update, this.formData);
          //alert('submitted');
          //console.log('Form submitted successfully:', response.data.token);
          // Handle successful submission (e.g., navigate to a success page)

          if (response.data.code == "00") {
            //alert('Form submitted successfully');
            // this.showSuccessDialog = true;

            //this.confirm1();
            //this.successMessage="Application saved successfully";
            //this.showSuccessDialog = true;
            this.token = '';
            this.retrieval_email = '';
            this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Application saved successfully', life: 4000 });

            //this.activateModule('start');


            if (this.autoSaveInterval) {
              clearInterval(this.autoSaveInterval);
            }

            this.$router.push({ name: 'Complete', params: { params: 'update' } });
            this.saving = false;
            // this.resetForm();
          }
        } catch (error) {
          this.errorMessage = "Unable to save form at this time. Kindly retry later";
          this.showErrorDialog = true;
          //alert("error submitting");
          //console.error('Error submitting form:', error);
          // Handle error (e.g., display an error message)
          this.saving = false;


        }
      }
    },


    async autoSave() {

      if (!this.fieldsEmpty()) {

        // if (this.formData.email1 == this.old_email) {
        this.saving = true;
        try {
          this.formData.operations_evidence = JSON.stringify(this.operation_evidence_docs);
          this.formData.green_evidence = JSON.stringify(this.green_practice_docs);
          this.formData.osh_upload = JSON.stringify(this.osh_docs);
          this.formData.green_practice_select = JSON.stringify(this.formData.green_practice_select);
          this.formData.indicate_loan_type = JSON.stringify(this.formData.indicate_loan_type);
          this.formData.osh_select = JSON.stringify(this.formData.osh_select);
          const response = await axios.post(endpoints.autosave, this.formData);

          if (response.data.code == "00") {

            this.formData = response.data.record;
            this.operation_evidence_docs = JSON.parse(this.formData.operations_evidence);
            this.green_practice_docs = JSON.parse(this.formData.green_evidence);
            this.osh_docs = JSON.parse(this.formData.osh_upload);
            this.formData.green_practice_select = JSON.parse(this.formData.green_practice_select);
            this.formData.indicate_loan_type = JSON.parse(this.formData.indicate_loan_type);
            this.formData.osh_select = JSON.parse(this.formData.osh_select);


            this.is_update = true;
            //this.$toast.add({ severity: 'success', summary: 'Auto Save', detail: 'Progress Saved', life: 4000 });
            this.saveProgressConfirmation()
            this.saving = false;

          }
        } catch (error) {
          //this.errorMessage = "Unable to save form at this time. Kindly retry later";
          //this.showErrorDialog = true;
          //alert("error submitting");
          //console.error('Error submitting form:', error);
          // Handle error (e.g., display an error message)
          this.saving = false;

        }
      }
      // } else {
      //   window.scrollTo({ top: 250, behavior: 'smooth' });
      //   this.$toast.add({ severity: 'error', summary: 'Mandatory Section', detail: 'Some fields are missing or incorrect. Please fix them to proceed', life: 6000 });
      //   // this.confirm1();
      // }



    },

    debouncedAutoSave: debounce(function () {
      this.autoSave();
    }, 1000), // 1000ms debounce time


    // // Auto-save triggered on input, debounced to prevent too many saves
    // triggerAutoSave: debounce(function () {
    //   this.autoSave();
    // }, 1000), // 1-second debounce

    async retrieveForm() {

      if (!this.token || this.token.trim() === '') {
        return;
      }
      let postData = {
        "email": this.retrieval_email,
        "token": this.token
      }
      this.sending_token = true;
      try {
        const response = await axios.post(endpoints.retrieve, postData);



        if (response.data.code == "00") {
          //alert('Form submitted successfully');
          // this.showSuccessDialog = true;

          //this.confirm1();
          this.formData = response.data.record;
          this.operation_evidence_docs = JSON.parse(this.formData.operations_evidence);
          this.green_practice_docs = JSON.parse(this.formData.green_evidence);
          this.osh_docs = JSON.parse(this.formData.osh_upload);
          this.formData.green_practice_select = JSON.parse(this.formData.green_practice_select);
          this.formData.indicate_loan_type = JSON.parse(this.formData.indicate_loan_type);
          this.formData.osh_select = JSON.parse(this.formData.osh_select);

          this.old_email = this.formData.email1;
          this.is_update = true;
          this.activateModule('main');
          this.sending_token = false;

        } else {
          this.sending_token = false;
          this.$toast.add({ severity: 'error', summary: 'Mandatory Fields', detail: 'Unable to retrieve form', life: 3000 });
          this.token_received = false;

          this.$router.push({ name: 'Apply', params: { params: 'start' } });

          // this.activateModule('start');
        }
      } catch (error) {
        this.showErrorDialog = true;
        //alert("error submitting");
        //console.error('Error submitting form:', error);
        // Handle error (e.g., display an error message)
        this.sending_token = false;


      }
    },

    goBack() {
      this.formData.step -= 1;
    },


    goNext() {

      this.formData.step += 1;

      // if (this.checkEligibility()) {
      //   this.$toast.add({ severity: 'error', summary: 'Ineligible', detail: 'Your business does not meet the eligibility criteria to apply for this program.', life: 6000 });
      //   return;
      // }


      // inject transition styles once
      // const styleId = 'gff-step-transition-styles';
      // if (!document.getElementById(styleId)) {
      //   const style = document.createElement('style');
      //   style.id = styleId;
      //   style.innerHTML = `
      //     @keyframes gffSlideOutLeft { from { transform: translateX(0); opacity:1 } to { transform: translateX(-20px); opacity:0 } }
      //     @keyframes gffSlideInRight { from { transform: translateX(20px); opacity:0 } to { transform: translateX(0); opacity:1 } }
      //     .slide-out-left { animation: gffSlideOutLeft .35s ease forwards; }
      //     .slide-in-right { animation: gffSlideInRight .35s ease forwards; }
      //   `;
      //   document.head.appendChild(style);
      // }

      // const form1 = document.getElementById('form1');
      // if (!form1) {
      //   this.formData.step = 2;
      //   return;
      // }

      // play slide-out on step1, then switch step and play slide-in on step2
      // new Promise((resolve) => {
      //   form1.classList.add('slide-out-left');
      //   form1.addEventListener('animationend', () => {
      //     form1.classList.remove('slide-out-left');
      //     resolve();
      //   }, { once: true });
      // }).then(() => {
      //   this.formData.step = 2;
      //   this.$nextTick(() => {
      //     const form2 = document.getElementById('form2');
      //     if (form2) {
      //       form2.classList.add('slide-in-right');
      //       form2.addEventListener('animationend', () => {
      //         form2.classList.remove('slide-in-right');
      //         // Scroll to the "New Application" header at the very top of the form
      //         const header = document.querySelector('#main .form-step h2');
      //         if (header) {
      //           try {
      //             header.scrollIntoView({ behavior: 'smooth', block: 'start' });
      //           } catch (e) {
      //             // fallback to computed position if scrollIntoView fails
      //             window.scrollTo({ top: header.getBoundingClientRect().top + window.pageYOffset, behavior: 'smooth' });
      //           }
      //         } else {
      //           // final fallback: scroll to top of page
      //           window.scrollTo({ top: 0, behavior: 'smooth' });
      //         }
      //       }, { once: true });
      //     } else {
      //       // fallback: scroll to top of the page
      //       const header = document.querySelector('#main .form-step h2');
      //       if (header) {
      //         try {
      //           header.scrollIntoView({ behavior: 'smooth', block: 'start' });
      //         } catch (e) {
      //           window.scrollTo({ top: header.getBoundingClientRect().top + window.pageYOffset, behavior: 'smooth' });
      //         }
      //       } else {
      //         window.scrollTo({ top: 0, behavior: 'smooth' });
      //       }
      //     }
      //   });
      // });

    },


    async sendToken() {

      if (this.retrieval_email == '') {
        return;
      }
      this.showRetryDialog = false;
      let postData = {
        "email": this.retrieval_email
      }
      this.sending_token = true;
      try {
        const response = await axios.post(endpoints.sendtoken, postData);
        //alert('submitted');

        // Handle successful submission (e.g., navigate to a success page)

        if (response.data.code == "00") {
          //alert('Form submitted successfully');


          this.successMessage = "Token sent successfully."
          this.showSuccessDialog = true;
          this.sending_token = false;
          this.token_received = true; // hide email text
          this.canResendToken = false // Hide resend
          this.startCountDown()
          // this.resetForm();
        } else if (response.data.code == "02") { // record not found
          //alert('hello')
          this.recordNotFound();


        } else {
          this.errorMessage = 'Unable to send token at this time. Try again later';
          this.token = '';
          this.showErrorDialog = true;
          this.sending_token = false;
        }
      } catch (error) {

        this.showRetryDialog = true;
        //alert("error submitting");
        //console.error('Error submitting form:', error);
        // Handle error (e.g., display an error message)
        this.sending_token = false;


      }
    },


    resetForm() {
      this.formData = {
        application_id: '',
        reference_number: '',
        fullname1: '',
        position1: '',
        email1: '',
        phone1: '',
        fullname2: '',
        position2: '',
        email2: '',
        phone2: '',
        step: 1,
        gh_registered: '',
        business_certificate: '',
        operational: '',
        transport: '',
        giz_support: '',
        specify_support: '',
        staff_available: '',
        business_name: '',
        business_registration: '',
        reg_monthyear: '',
        region: '',
        town: '',
        digital_address: '',
        business_activity: '',
        other_business_activity: '',
        main_products: '',
        ownership_type: '',
        other_ownership_type: '',
        website: '',
        owner_name: '',


      }
    },

    //confirmations
    confirm1(event) {
      this.$confirm.require({
        target: event.currentTarget,
        message: 'Form submitted successfully',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        rejectClass: 'p-button-secondary p-button-outlined',
        rejectLabel: 'OK',
        acceptLabel: 'OK',
        accept: () => {
          //this.$toast.add({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
          // window.location.replace("https://jcs.com.gh");

        },
        // reject: () => {
        //     this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
        // }
      });
    },

    submitConfirmation() {
      this.$confirm.require({
        // target: event.currentTarget,
        message: 'You are about to submit your request?',
        header: 'Confirm Submission',
        icon: 'pi pi-info-circle text-primary',
        rejectClass: 'p-button-secondary p-button-outlined',
        rejectLabel: 'Cancel',
        acceptLabel: 'Proceed',
        accept: () => {
          //this.$toast.add({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
          // window.location.replace("https://jcs.com.gh");
          this.handleSubmit();
        },
        // reject: () => {
        //     this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
        // }
      });
    },


    saveProgressConfirmation() {
      this.$confirm.require({
        // target: event.currentTarget,
        message: 'Progress Saved. Would you like to exit?',
        header: 'Application Saved',
        icon: 'pi pi-info-circle text-primary',
        rejectClass: 'p-button-secondary',

        rejectLabel: 'Continue',
        acceptLabel: 'Exit',
        accept: () => {
          this.$router.push({ name: 'Home' });
          //this.$toast.add({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
          // window.location.replace("https://jcs.com.gh");
          //this.handleSubmit();
        },
        // reject: () => {
        //     this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
        // }
      });
    },

    emailDuplicateDialog() {
      this.$confirm.require({
        //target: event.currentTarget,

        message: 'This email is already in our records. Would you like to resume your saved application?',
        header: 'Duplicate Record',
        icon: 'pi pi-info-circle text-yellow-500',
        rejectClass: 'p-button-secondary p-button-outlined',
        rejectLabel: 'No',
        acceptLabel: 'Yes',
        accept: () => {
          //this.$toast.add({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
          this.$router.push({ name: 'Home' });

        },
        // reject: () => {
        //     this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
        // }
      });
    },


    recordNotFound() {
      this.$confirm.require({
        //target: event.currentTarget,
        message: 'Record was not found. Would you like to start a new application?',
        header: 'Not Found',
        icon: 'pi pi-info-circle text-yellow-600',
        rejectClass: 'p-button-secondary p-button-outlined',
        rejectLabel: 'No',
        acceptLabel: 'Yes',
        accept: () => {

          this.$router.push({ name: 'Home' });
          //window.location.replace("https://jcs.com.gh");

        },
        reject: () => {
          this.sending_token = false;
        }
      });
    },


    confirm2() {
      this.$confirm.require({
        message: 'Do you want to delete this record?',
        header: 'Danger Zone',
        icon: 'pi pi-info-circle',
        rejectLabel: 'Cancel',
        acceptLabel: 'Delete',
        rejectClass: 'p-button-secondary p-button-outlined',
        acceptClass: 'p-button-danger',
        accept: () => {
          this.$toast.add({ severity: 'info', summary: 'Confirmed', detail: 'Record deleted', life: 3000 });
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
        }
      });
    },

    onAdvancedUpload() {
      this.$toast.add({ severity: 'info', summary: 'Success', detail: 'File Uploaded', life: 3000 });
    },

    async onFileSelect(event) {
      const file = event.files[0];
      if (!file) return;

      const formData = new FormData();
      formData.append('file', file);

      try {
        const response = await axios.post(endpoints.uploadphoto + "/profile", formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          onUploadProgress: progressEvent => {
            this.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          }
        });

        // Assuming the API returns an object with the file path
        // this.filePath = response.data.filePath;
        // console.log(response.data);
        this.formData.photo = response.data;
      } catch (error) {
        console.error('Error uploading file:', error);
        // Handle error accordingly
      } finally {
        // Reset the upload progress after completion
        this.uploadProgress = 0;
      }
    },

    onRemoveTemplatingFile(file, removeFileCallback, index) {
      removeFileCallback(index);
      this.totalSize -= parseInt(this.formatSize(file.size));
      this.totalSizePercent = this.totalSize / 10;
    },

    activateModule(module) {



      if (module == 'main') {

        this.main = true;
        this.start = false;
        this.resume = false
      } else if (module == 'start') {

        this.main = false;
        this.start = true;
        this.resume = false
      } else if (module == 'resume') {

        if (this.autoSaveInterval) {
          clearInterval(this.autoSaveInterval);
        }
        this.main = false;
        this.start = false;
        this.resume = true
      }
    },


    onUpload(event, field) {

      this.formData[field] = event.xhr.response;

    },

    onOtherUpload(event, target) {

      //this.formData[field] = event.xhr.response;
      //this.other_docs.push(event.xhr.response)
      let url = event.xhr.response

      //let name = this.other_doc_name

      // if (name == 'Other') {
      //   name = this.other_doc_name_specify;
      // }
      //console.log(url)
      //this.other_docs.push({ name: name, url: url });
      if (target == 'operations_evidence') {
        this.operation_evidence_docs.push({ url: url });


      } else if (target == 'green_practice') {
        this.green_practice_docs.push({ url: url });
      } else if (target == 'osh') {
        this.osh_docs.push({ url: url });
      }
      //this.other_doc_name = ''
      this.other_uploading = false;
    },

    onOtherUploadSelected() {
      // if(){

      // }
      this.other_uploading = true;
    },

    checkEmptyDocName() {
      if (this.other_doc_name == '' && this.other_doc_name_specify == '') {
        alert('Please enter Document Category before selecting file')
      }
    },

    fieldsEmpty() { // checks if mandatory fields for saving are empty


      this.v$.formData.fullname1.$touch();
      this.v$.formData.email1.$touch();
      // this.v$.formData.email.$touch();
      // this.v$.formData.street_address.$touch();
      // this.v$.formData.city.$touch();
      // this.v$.formData.region.$touch();
      // this.v$.formData.mobile.$touch();
      // this.v$.formData.home_phone.$touch();

      if (
        this.v$.formData.fullname1.$error ||
        this.v$.formData.email1.$error
        // this.v$.formData.email.$error ||
        // this.v$.formData.street_address.$error ||
        // this.v$.formData.city.$error ||
        // this.v$.formData.region.$error ||
        // this.v$.formData.mobile.$error
        //this.v$.formData.home_phone.$error 
      ) {

        return true
      } else {
        return false;
      }

      //   if (this.formData.firstname == '' || 
      //   this.formData.lastname == '' || 
      //   this.formData.email == '' || 
      //   this.formData.mobile == '' ||
      //   this.formData.mobile == '' ||
      //   this.formData.mobile == '' ||
      //   this.formData.mobile == '' ||

      // ) {

      //     return true
      //   } else {

      //     return false;
      //   }



    },

    fieldsEmptyAuto() { // autosave mandatory check


      if (this.formData.fullname1 == '' ||
        this.formData.email1 == ''
        // this.formData.email == '' ||
        // this.formData.street_address == '' ||
        // this.formData.city == '' ||
        // this.formData.region == '' ||
        // this.formData.mobile == ''
      ) {

        return true
      } else {

        return false;
      }



    },

    addOwner() {
      // Add a new blank owner to the owners array
      this.ownership.push({ name: '', percentage: '', role: '' });
    },
    removeOwner(index) {
      // Remove owner at the specified index
      this.ownership.splice(index, 1);
    },

    removeOtherDoc(index, target) {
      // Remove owner at the specified index
      //this.other_docs.splice(index, 1);

      if (target == 'operations_evidence') {
        this.operation_evidence_docs.splice(index, 1);
      } else if (target == 'green_practice') {
        this.green_practice_docs.splice(index, 1);
      } else if (target == 'osh') {
        this.osh_docs.splice(index, 1);
      }
    },

    completeRedirect() {
      this.showCompleteDialog = false;
      window.location.replace("https://greenfinancefacilitator.com");

    },

    formatSize(bytes) {
      const k = 1024;
      const dm = 3;
      const sizes = this.$primevue.config.locale.fileSizeTypes;

      if (bytes === 0) {
        return `0 ${sizes[0]}`;
      }

      const i = Math.floor(Math.log(bytes) / Math.log(k));
      const formattedSize = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));

      return `${formattedSize} ${sizes[i]}`;
    },
    downloadForm(format) {
      // Path to your PDF file

      let filePath = "https://greenfinancefacilitator.com/documents/The_GFF_Application_Form.pdf";
      let filename = "GFF_Application_Form.pdf"
      if (format == 'excel') {
        filePath = "https://greenfinancefacilitator.com/documents/The_GFF_Application_Form.xlsx"
        filename = "GFF_Application_Form.xlsx"
      }
      // Create an invisible link element
      const link = document.createElement("a");
      link.href = filePath;
      link.download = "file.pdf"; // Specify the file name
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    async checkEmailDuplicate(event) {
      this.v$.formData.email.$touch()
      if (this.old_email != this.formData.email) {


        if (!this.v$.formData.email.$error) {

          let email = encodeURIComponent(this.formData.email);
          let url = endpoints.checkemailexists + email
          //this.sending_token = true;
          try {
            const response = await axios.get(url);

            if (response.data == true) {

              this.emailDuplicateDialog()
              this.formData.email = '';
              this.v$.formData.email.$touch();

            } else {
              if (this.old_email != this.formData.email) {

                this.old_email = this.formData.email; //store this for autosave security check
              }


            }
          } catch (error) {
            // console.log(error)
            //this.showErrorDialog = true;



          }
        }
      }






    },
    startCountDown() {
      let duration = parseInt(this.$route.query.duration) || 5; // in minutes
      let minutes = 60 * duration;
      let timer = minutes;
      let seconds;
      var self = this;
      const interval = setInterval(function () {
        minutes = parseInt(timer / 60, 10);
        seconds = parseInt(timer % 60, 10);
        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;
        self.countDown = minutes + ":" + seconds;
        if (--timer < 0) {
          clearInterval(interval);
          self.tokenExpired = "Token has expired";
          self.countDown = "Token has expired";
          self.canResendToken = true;
        }
      }, 1000);
    },

    populateSubsector() {

      this.formData.subsector = "";

      this.subsectorOptions = this.formData.sector_json.subsectors;
      this.formData.sector_code = this.formData.sector_json.code;
      this.formData.sector = this.formData.sector_json.name;
      this.formData.subsector_code = this.formData.sector_json.subsectors[0].code;
      this.formData.subsector = this.formData.sector_json.subsectors[0].name;

      console.log(this.formData.sector_json)


    },

    checkEligibility() {
      if (this.formData.gh_registered == 'No' ||
        this.formData.operational == 'No' ||
        this.formData.transport == 'No' ||
        this.formData.staff_available == 'No'

      ) {
        return false;
      }
    }



  }


};
</script>



<style>
body {
  background-color: #e9ebec;
  /* background: url('../assets/bg.jpg') center center no-repeat fixed; */
  background-size: cover
}

/* .startcss {
  background: url('../assets/bg.jpg') center center no-repeat fixed;
  background-size: cover
} */

/* .container {
    max-width: 900px;
    margin: 0 auto;
    padding: 20px;
    background-color: rgba(62, 136, 27, 0.527);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    
   
  } */

.text-center {
  text-align: center;
}

.mb-4 {
  margin-bottom: 1.5rem;
}

.mr-4 {
  margin-right: 0.5rem;
}

.mt-5 {
  margin-top: 3rem;
}

.form-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

/* .form-step {
  display: flex;
  flex-direction: column;
  gap: 20px;
} */

.form-group {
  display: flex;
  flex-direction: column;
}

.form-row {
  display: flex;
  gap: 20px;
}

.form-label {
  margin-bottom: 0.5rem;
}

.form-radio-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.radio-label {
  margin-left: 0.5rem;
}

.form-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

video {
  border: 1px solid #ccc;
  border-radius: 10px;
  margin-bottom: 10px;
}

canvas {
  display: none;
}

img {

  border-radius: 10px;
  margin-top: 10px;
}

.error-message {
  color: red;
  margin-top: 10px;
  font-size: medium;
  font-weight: bold;
}

.success-message {
  color: rgba(29, 141, 54, 0.877);
  margin-top: 10px;
  font-size: medium;
  font-weight: bold;
}

video {
  max-width: 100%;
  height: auto;
}

.error-msg {
  margin: 0.2rem;
  color: rgb(218, 61, 61);
  font-size: 0.7rem;
  font-weight: 700
}

.required {
  color: rgb(218, 61, 61);
}

label {
  color: rgb(56, 56, 53);
  font-size: 0.8rem;
  font-weight: 800;
  margin-bottom: 0.2rem;

}

h3 {
  color: rgb(56, 56, 53);
}

nav {
  background-color: #f4f6fb;

}

a {
  text-decoration: none;
  font-weight: bold;
}

a:hover {
  color: #005fa3;
}


/* To remove the shadow completely */
/* .p-card {
  box-shadow: none !important;
} */

/* Or to apply a lighter shadow */
.p-card {
  border-radius: 8px;
  background: #fff;
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.12),
    0 6px 16px rgba(0, 0, 0, 0.08),
    0 20px 40px rgba(0, 0, 0, 0.04);
  transition: box-shadow 200ms ease, transform 200ms ease;
  will-change: transform, box-shadow;
}

/* subtle lift on hover for nicer elevation */
/* .p-card:hover {
  box-shadow:
    0 10px 20px rgba(0, 0, 0, 0.14),
    0 22px 44px rgba(0, 0, 0, 0.10),
    0 40px 80px rgba(0, 0, 0, 0.06);
  transform: translateY(-6px);
} */
</style>